/* eslint-disable eqeqeq,no-param-reassign,no-unreachable,object-shorthand */

import en from '../../locales/en';
import { logout } from '../../app/account/store/account.actions';

window.DEFAULT_TIMEZONE = '+0000';

const interpolate = (tpl, args) => tpl.replace(/\{(\s*\w+\s*)}/g, (_, v) => args[v.replace(/\s*/g, '')]);

xplenty.factory('customInterpolation', [
  '$interpolate',
  '$translateSanitization',
  function ($interpolate, $translateSanitization) {
    let $locale;

    return {
      setLocale: function (locale) {
        $locale = locale;
      },

      getInterpolationIdentifier: function () {
        return 'custom';
      },

      interpolate: function (string, interpolateParams, context, sanitizeStrategy) {
        string = $translateSanitization.sanitize(string, 'text', sanitizeStrategy);
        if (interpolateParams) {
          interpolateParams = $translateSanitization.sanitize(interpolateParams, 'params', sanitizeStrategy);
        }
        return interpolate(string, interpolateParams);
      },
    };
  },
]);

// i18n
xplenty.config([
  '$provide',
  '$translateProvider',
  '$urlRouterProvider',
  '$httpProvider',
  'RollbarProvider',
  '$sceDelegateProvider',
  '$compileProvider',
  function (
    $provide,
    $translateProvider,
    $urlRouterProvider,
    $httpProvider,
    RollbarProvider,
    $sceDelegateProvider,
    $compileProvider,
  ) {
    $sceDelegateProvider.resourceUrlWhitelist(['self', process.env.PIPEDRIVE_URL, process.env.PIPEDRIVE_RETURN_URL]);
    if (process.env.NODE_ENV !== 'development') {
      $compileProvider.debugInfoEnabled(false);
      RollbarProvider.init({
        accessToken: process.env.ROLLBAR_ACCESS_TOKEN,
        captureUncaught: true,
        captureUnhandledRejections: true,
        payload: {
          environment: process.env.ROLLBAR_ENV,
          code_version: process.env.SOURCE_VERSION,
          guess_uncaught_frames: true,
        },
        ignoredMessages: [
          'Object Not Found Matching Id:4',
          'Failed to fetch',
          '(unknown): Script error.',
          'Script error.',
        ],
      });
    }
    $urlRouterProvider.deferIntercept();

    $httpProvider.interceptors.push('httpInterceptor');

    $translateProvider.translations('en', en);
    $translateProvider.preferredLanguage('en');
    $translateProvider.fallbackLanguage('en');
    $translateProvider.useSanitizeValueStrategy(null);
    $translateProvider.useInterpolation('customInterpolation');
    $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

    $provide.decorator('dateFilter', [
      function () {
        const standardDateFilterInterceptor = function (date, format, timezone) {
          const t = moment(date);
          if (!angular.isUndefined(timezone)) {
            t.utcOffset(timezone);
          }
          if (angular.isUndefined(format)) {
            // Default format
            format = `MMM Do${moment().year() == t.year() ? ' ' : `, ${t.year()}`}`;
          } else if (format === 'SCHEDULE') {
            format = `MMM Do${moment().year() == t.year() ? ' ' : `, ${t.year()}`} [at] LT`;
          }

          return t.format(format);
        };
        return standardDateFilterInterceptor;
      },
    ]);
  },
]);

xplenty.factory('httpInterceptor', [
  '$q',
  '$rootScope',
  '$translate',
  'notify',
  'ngrxStoreService',
  function ($q, $rootScope, $translate, notify, ngrxStoreService) {
    return {
      responseError(response) {
        switch (response.status) {
          case 400: // Bad Request: The request was invalid. An accompanying error message will explain why.
            return $q.reject(response);
          case 401: // Unauthorized: You are attempting to access the API with invalid credentials.
            ngrxStoreService.dispatch(logout({ shouldRedirect: true }));
            return $q.reject(response);
          case 402: // Payment Required: You must confirm your billing info to use this API.
            notify.error(null, $translate.instant(`response.${response.status}.message`));
            return $q.reject(response);
          case 403: // Forbidden: The request has been refused. An accompanying error message will explain why.
            notify.error(null, $translate.instant(`response.${response.status}.message`));
            return $q.reject(response);
          case 404: // Not Found: The URI requested is invalid or the resource requested does not exist.
            // TODO: Redirect to 404 view?
            return $q.reject(response);
          case 406: // Not Acceptable: The requested mime-type is not acceptable.
          case 415: // Unsupported Media Type: The specified media type is not supported.
            // notify.error(null, $translate.instant("response."+response.status+".message"));
            return $q.reject(response);
          case 422: // Unprocessable Entity: You have sent invalid fields.
            if (response.data.message && response.data.message.includes('flow_type')) {
              notify.error(null, $translate.instant(`response.${response.status}.message_wrong_flow_type`));
              return $q.reject(response);
            }

            // eslint-disable-next-line no-case-declarations
            const params = { message: '' };
            if (response.data.message) {
              params.message = response.data.message;
            }

            notify.error(null, $translate.instant(`response.${response.status}.message`, params));
            return $q.reject(response);
          case 429: // Too Many Requests: The request exceeded the rate limitations.
          case 500: // Internal Server Error: An internal error occurred in the request.
            notify.error(null, $translate.instant(`response.${response.status}.message`));
            return $q.reject(response);
          case 502: // Bad Gateway: Xplenty is down or being upgraded.
          case 503: // Service Unavailable: The Xplenty servers are up, but overloaded with requests. Try again later.
            notify.error(null, $translate.instant(`response.${response.status}.message`));
            return $q.reject(response);
          case -1: // Request timed out
            return $q.reject(response);
          default:
            return $q.reject(response);
        }
      },
    };
  },
]);
